<template>
  <div class="container">
    <div class="border-bottom p-t-md p-b-md">
      <div class="container">
        <a href="/">
          <i
            class="fas fa-arrow-circle-left"
            aria-hidden="true"
          />
          Go home
        </a>
      </div>
    </div>
    <div class="container m-t-lg">
      <div class="columns">
        <div class="column is-6 is-offset-3">
          <div class="content m-b-md">
            <template v-if="$route.params.status === 'success'">
              <h2 class="has-text-centered">
                Payment received
              </h2>
              <p>Your transaction is being processed and you will receive a confirmation receipt by email.</p>
              <p>
                Payments may not be reflected in the Case History immediately. If you do not receive confirmation of payment within 2 hours, <router-link :to="{ name: 'contact-us' }">
                  contact LHHP
                </router-link>.
              </p>
            </template>
            <template v-else-if="$route.params.status === 'failure'">
              <h2 class="has-text-centered">
                Payment failed
              </h2>
              <p>Your transaction was not processed successfully and no payment has been received.</p>
              <p>If you completed the payment process, you will receive a confirmation email with details of the reasons the payment failed. Don’t attempt another transaction before receiving that email.</p>
              <p>If you did not complete the payment process, you can return to your case to attempt another payment now.</p>
              <p>
                If you continue to receive this message or for assistance making a payment <router-link :to="{ name: 'contact-us' }">
                  contact LHHP
                </router-link>
              </p>
            </template>
            <p
              v-if="$route.params.uuid"
              class="has-text-centered"
            >
              <router-link :to="{ name: 'single-case', params: { uuid: $route.params.uuid }}">
                Open the case
              </router-link>
            </p>
            <p
              v-else
              class="has-text-centered"
            >
              <router-link :to="{ name: 'cases' }">
                View all cases
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentResponse',
};
</script>

<style>
</style>